import { lazy, Suspense } from 'react';
import type { Navigation } from '@/app/contract';

const AddAccountSheet = lazy(() => import('./AddAccountSheet'));
const AccountsSheet = lazy(() => import('./AccountsRows').then(module => ({ default: module.AccountsSheet })));

export function presentAddAccount(nav: Navigation, handle?: string) {
  let close = () => {};
  close = nav.present(<Suspense fallback={null}><AddAccountSheet handle={handle} onClose={() => close()} /></Suspense>, { size: 'medium' }).dismiss;
}
export function presentAccounts(nav: Navigation) {
  let close = () => {};
  close = nav.present(<Suspense fallback={null}><AccountsSheet onClose={() => close()} /></Suspense>, { size: 'medium' }).dismiss;
}
